import React from 'react';
import { AttachedFilesBaseUploadForm } from '../../../_lib/components/AttachedFilesBase';
import IForm from '../../../types/IForm';
import { ComboBoxParam, SonForm } from '../../../_lib/Form2';

export function AttachedFilesUploadCreateForm({
  fileLink,
  fileUpload,
}: {
  fileLink: SonForm<ComboBoxParam<'fileResourceReference'>>;
  fileUpload: IForm;
}) {
  return <AttachedFilesBaseUploadForm id="attached-file-upload-form" fileLink={fileLink} fileUpload={fileUpload} />;
}
